import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useNavigate } from "react-router-dom";

export const TokenExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-muted flex min-h-full flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="flex w-full max-w-md flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <img src="/logo-black.svg" alt="Rebuild" className="h-8" />
        </a>
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Login Link Expired</CardTitle>
            <CardDescription>
              The link you clicked has expired. For security reasons, our links
              are only valid for a limited time.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" onClick={() => navigate("/")}>
              Try again
            </Button>
          </CardContent>
        </Card>
        <div className="text-balance text-center text-xs text-muted-foreground">
          Need help?{" "}
          <a
            href="mailto:admin@rebuild.work"
            className="underline underline-offset-4 hover:text-primary"
          >
            Contact support
          </a>
        </div>
      </div>
    </div>
  );
};
